<template>
  <el-dialog
    title="Reject"
    :visible.sync="isOpen"
    width="7rem"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
    @close="close"
  >
    <el-form
      class="page-form"
      ref="pageForm"
      :model="pageData"
      :rules="pageRules"
    >
      <el-form-item prop="refusalReason" label="Approval Instructions">
        <el-input
          v-model="pageData.refusalReason"
          type="textarea"
          auto-complete="off"
          placeholder="Please fill in"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer page-btns">
      <el-button @click="close('cancel')">Cancel</el-button>
      <loading-btn type="primary" label="Submit" @clickHandle="approval" />
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOpen: false,
      minAmount: "0.00001",
      pageData: {
        refusalReason: undefined
      },
      pageRules:{
        refusalReason:[
          {
            required: true,
            trigger: "blur",
            message: "Please fill in"
          }
        ]
      }
    };
  },
  computed: {},
  methods: {
    open({ pageData } = {}) {
      this.isOpen = true;
    },
    close(isCancel) {
      if(isCancel){
        this.$emit("cancel");
      }

      this.isOpen = false;
      this.pageData = {
        refusalReason: undefined
      };
    },
    approval(btn) {
      this.$refs.pageForm.validate((valid) => {
        if(valid){
          btn.closeLoad();
          this.$emit("success", this.pageData.refusalReason);
          this.close();
        }else{
          btn.closeLoad();
        }
       });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
.desc {
  font-size: 0.16rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 0.24rem;
  margin-top: 0.16rem;
}
.num {
  font-size: 0.28rem;
  font-weight: 500;
  color: #1f1f1f;
}
.notReceived {
  font-size: 0.22rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.32rem;
  i {
    font-size: 0.24rem;
    color: #faad14;
    margin-right: 0.12rem;
  }
}
</style>
